var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepairProduct = function SvgRepairProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m2.596 11.872 17.67 10.218 17.552-10.17M20.267 40.238V22.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.486 22.661V15.35c0-2.762-1.977-6.12-4.406-7.454l-10.693-5.93c-2.287-1.287-6.002-1.287-8.288 0L5.406 7.895C2.976 9.229 1 12.587 1 15.35v11.312c0 2.763 1.977 6.121 4.406 7.455l10.693 5.93c1.143.643 2.643.953 4.144.953 1.5 0 3-.31 4.144-.953"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M33.913 39.81a7.135 7.135 0 0 0 7.144-7.146 7.135 7.135 0 0 0-7.144-7.145 7.135 7.135 0 0 0-7.145 7.145 7.135 7.135 0 0 0 7.145 7.145"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m30.864 33.403 1.953 1.953 4.192-3.859"
  })));
};
export default SvgRepairProduct;